// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:where(.vuetify-styles) .v-responsive {
  display: flex;
  flex: 1 0 auto;
  max-height: 100%;
  max-width: 100%;
  overflow: hidden;
  position: relative;
}
:where(.vuetify-styles) .v-responsive--inline {
  display: inline-flex;
  flex: 0 0 auto;
}

:where(.vuetify-styles) .v-responsive__content {
  flex: 1 0 0px;
  max-width: 100%;
}

:where(.vuetify-styles) .v-responsive__sizer ~ .v-responsive__content {
  margin-inline-start: -100%;
}

:where(.vuetify-styles) .v-responsive__sizer {
  flex: 1 0 0px;
  transition: padding-bottom 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  pointer-events: none;
}`, "",{"version":3,"sources":["webpack://./node_modules/vuetify/lib/components/VResponsive/VResponsive.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,oBAAoB;AACtB","sourcesContent":[".v-responsive {\n  display: flex;\n  flex: 1 0 auto;\n  max-height: 100%;\n  max-width: 100%;\n  overflow: hidden;\n  position: relative;\n}\n.v-responsive--inline {\n  display: inline-flex;\n  flex: 0 0 auto;\n}\n\n.v-responsive__content {\n  flex: 1 0 0px;\n  max-width: 100%;\n}\n\n.v-responsive__sizer ~ .v-responsive__content {\n  margin-inline-start: -100%;\n}\n\n.v-responsive__sizer {\n  flex: 1 0 0px;\n  transition: padding-bottom 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n  pointer-events: none;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
